import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import {  Subject, Subscription } from "rxjs";
import { StatusRegra } from "../../resultado-regra/resultado-regra/status-regra";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AutocompleteLoadingModeType, IAutocompleteSchema, IDatepickerSchema, ToastService } from "maps-angular-components";
import { Carteira, CarteiraAutocompleteModel } from "src/app/carteira/carteira.model";
import { Regra } from "src/app/regra/regra";
import { CarteiraService } from "src/app/carteira/carteira.service";
import { RegraService } from "src/app/regra/regra.service";
import { CarteiraGrupoAutocompleteService } from "src/app/carteira/carteira-grupo-autocomplete.service";
import { HistoricoService } from "../historico.service";
import { indicate } from "../../shared/util/loading-indicate";
import { ExecucaoHistorico } from "../historico";
import { BrowserSupport } from "src/app/shared/util/browser-support";

@Component({
    selector: "app-historico-pesquisa",
    templateUrl: "./historico-pesquisa.component.html",
    styleUrls: [
        "./historico-pesquisa.component.scss",
        "../../shared/form-component.css",
    ]
})
export class HistoricoPesquisaComponent implements OnInit, OnDestroy {

    form: FormGroup;
    private readonly subscriptions = new Subscription();
    status = StatusRegra.getStatusProcessamento;
    page$: Subject<number> = new Subject<number>();

    public carteiraSchema: IAutocompleteSchema<CarteiraAutocompleteModel>;
    public carteiraSchemaChip: IAutocompleteSchema<Carteira>;
    public regraSchema: IAutocompleteSchema<Regra>;
    public dataInicioSchema: IDatepickerSchema;
    public dataFimSchema: IDatepickerSchema;

    loadingAtualizar$: Subject<boolean> = new Subject<boolean>();
    loadingExecutar$: Subject<boolean> = new Subject<boolean>();
    loadingIgnored$: Subject<boolean> = new Subject<boolean>();
    paginationTotalPage = 1;
    public totalRegistros = 0;
    execucoes: [];
    public pageSize = 10;
    interval;
    public autoRefresh = true;

    constructor (
        private readonly formBuilder: FormBuilder,
        private readonly carteiraService: CarteiraService,
        private readonly regraService: RegraService,
        private readonly carteiraGrupoAutocompleteService: CarteiraGrupoAutocompleteService,
        private readonly historicoService: HistoricoService,
        private readonly messageService: ToastService,
        private readonly changeDetectorRef: ChangeDetectorRef,
    ) {

    }

    ngAfterViewInit(): void {
        this.pesquisar();
        this.interval = setInterval(() => {
          if (this.autoRefresh) this.refreshTable();
        }, 1000);
      }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            carteiraId: new FormControl(),
            regra: new FormControl(),
            status: new FormControl(),
            page: new FormControl(0),
        });

        this.page$.subscribe(value => {
            this.form.controls.page.setValue(value - 1);
            this.pesquisar();
        });


        this.carteiraSchema = {
            service: this.carteiraGrupoAutocompleteService,
            label: "",
            placeholder: "",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            autoload: false,
            endpoint: "",
            formGroup: this.form,
            formControlName: "carteiraId",
            panelClass: "large-input",
            parseSearchParam(search): string {
              return search;
            },
          };

        this.carteiraSchemaChip = {
            service: this.carteiraService,
            label: "Carteira (Carteira / Grupo carteira)",
            placeholder: "Nome da carteira",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            required: false,
            autoload: false,
            endpoint: "nome-ou-cnpj",
            formGroup: this.form,
            formControlName: "carteiraChip",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };

        this.regraSchema = {
            service: this.regraService,
            endpoint: "autocomplete/associacao/resultado",
            label: "Regra (Regra simples / Regra composta)",
            placeholder: "Regra selecionada",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            required: false,
            autoload: false,
            formGroup: this.form,
            formControlName: "regra",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };
        this.dataInicioSchema = {
            label: "Data início",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            required: true,
            panelClass: "w-100",
            formControlName: "dataInicio"
        };

        this.dataFimSchema = {
            label: "Data fim",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            required: true,
            panelClass: "w-100",
            formControlName: "dataFim"
        };
    }

    refreshTable() {
        this.subscriptions.add(
            this.pesquisarSemAtualizarTabela()
        )
    }

    pesquisarSemAtualizarTabela() {
        this.historicoService
            .search(this.form.value, this.pageSize)
            .pipe(indicate(this.loadingIgnored$))
            .subscribe(
                (r) => {
                    if (r.metadata.totalElements > 0) {
                        this.execucoes = [];
                        this.execucoes = r.content.map(e =>
                            Object.assign(new ExecucaoHistorico(), e)
                        );
                    } else {
                        this.paginationTotalPage = 1;
                    }
                },
                err => {
                    this.messageService.erro(err.error?.message || err.message);
                },
                () => this.changeDetectorRef.detectChanges()
            )
    }

    pesquisar() {
        this.totalRegistros = 0;
        this.subscriptions.add(
            this.historicoService
            .search(this.form.value, this.pageSize)
            .pipe(indicate(this.loadingAtualizar$))
            .subscribe(
                (r) => {
                    if (r.metadata.totalElements > 0) {
                        if (r.metadata.size === 0) {
                            this.paginationTotalPage = 1;
                        } else {
                            this.paginationTotalPage = Math.ceil(
                                r.metadata.totalElements / r.metadata.size
                            );
                        }
                        this.totalRegistros = r.metadata.totalElements;
                        this.execucoes = [];
                        this.execucoes = r.content.map(e =>
                            Object.assign(new ExecucaoHistorico(), e)
                        );
                        this.form.get("page").setValue(r.metadata.number);
                    } else {
                        this.paginationTotalPage = 1;
                    }
                },
                err => {
                    this.messageService.erro(err.error?.message || err.message);
                }
            )
        );
    }

    executar() {
        this.subscriptions.add(
            this.historicoService
            .executar(this.form.value)
            .pipe(indicate(this.loadingExecutar$))
            .subscribe(
                () => {
                    this.messageService.sucesso("Execução iniciada com sucesso! Acompanhe o status na tabela abaixo");
                    this.pesquisar();
                },
                err => {
                    this.messageService.erro(err.error?.message || err.message);
                }
            )
        );
    }

    download(id: number) {
        this.subscriptions.add(
            this.historicoService.download(id).pipe(indicate(this.loadingAtualizar$)).subscribe(data => {
                BrowserSupport.saveXlsx(data);
            }, err => this.messageService.erro(err.error.message)));
    }

    openParametersDialog(exec: ExecucaoHistorico) {

    }

    updatePageSize($event: number): void {
        this.pageSize = $event;
        this.page$.next(1);
    }

    receiverPage(value) {
        this.page$.next(value);
    }

    shouldDownload(exec: ExecucaoHistorico) {
        return exec.status == 'SUCESSO';
    }
      
    ngOnDestroy(): void {
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.subscriptions.unsubscribe();
      }

}